import axios from 'axios';
import { SessionExpiredError } from './SessionExpiredError';
// /v1/sat/documentacion-movil/generar-token
// /v1/sat/tramites/status/{token}

/**
 * Servicio para submit final del trámite
 * Actualiza el estado en Redis a 'submitted'
 */

/**
 * Valida el token y trae los datos del trámite
 * @param {Object} token - Datos del trámite
 * @returns {Promise<Object>} Respuesta del servidor
 */
export const validarTramite = async (token) => {
  try {
    const response = await axios.get(`/v1/sat/tramites/validar/${token}`);
    return response.data;
  } catch (error) {
    console.error('Error al tratar de validar el trámite por QR:', error);

    const statusCode = error.response?.status;
    const message = error.response?.data?.error;
    const isTokenInvalidOrExpired =
      message?.toLowerCase().includes('token') &&
      (message?.toLowerCase().includes('inválido') || message?.toLowerCase().includes('expirado'));

    if (statusCode === 422 && isTokenInvalidOrExpired) {
      throw new SessionExpiredError(statusCode, message);
    }

    throw new Error(message || error.message || 'Error al validar el QR del trámite');
  }
};
